module.exports = __webpack_public_path__ + "img/zzzx.55736b07.png";